import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    // Default networkMode 'online' PAUSES a mutation when the browser is
    // offline: the mutationFn never runs, no error is thrown, and isPending
    // stays true — leaving submit buttons stuck disabled with no error toast.
    // 'always' makes mutations attempt the request and fail fast offline so
    // each form's catch/toast path runs and the button re-enables.
    mutations: {
      networkMode: 'always',
    },
  },
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
